import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import HeaderBlock from '~/common/components/HeaderBlock';
import { SELECTED_NUMBER_TYPE } from '~/common/utils/consts';
import { qualtricsBannerInit, qualtricsBannerObserver } from '~/common/utils/qualtricsBanner';
import TwoColumn from '~/common/components/two-column';
import ThreeCell from '~/common/components/ThreeCell';
import { blogCardsData, twoColData, headerContent } from '~/common/data/signup-success';
import { gtm, viewContentEvent } from '~/common/utils/tracking.js';

@observer
@inject('lockNumberStore', 'trialSignupStore')
export default class SignupSuccess extends Component {
    componentDidMount() {
        const { lockNumberStore, trialSignupStore } = this.props;
        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
        qualtricsBannerInit();
        qualtricsBannerObserver();
        gtm(viewContentEvent(trialSignupStore.signupTrialSuccessful ? 'trial flow' : 'buy flow', 'checkout', SELECTED_NUMBER_TYPE[lockNumberStore.selectedNumberType]));
        window.onbeforeunload = null;
    }

    render() {
        const isTrialFlow = this.props.trialSignupStore.signupTrialSuccessful;
        const activeHeaderContent = isTrialFlow ? headerContent.trial : headerContent.buy;
        const activeTwoColData = isTrialFlow ? twoColData.trial : twoColData.buy;

        return (
            <div>
                <HeaderBlock
                    subtitle={activeHeaderContent.subtitle}
                    title={activeHeaderContent.title}
                />
                <TwoColumn
                    copy={activeTwoColData.copy}
                    ctaHref={activeTwoColData.href}
                    ctaText={activeTwoColData.ctaText}
                    header={activeTwoColData.header}
                    listContent={activeTwoColData.listContent}
                    video={activeTwoColData.video}
                    videoThumbnail={activeTwoColData.videoThumbnailImg}
                />
                <ThreeCell cells={blogCardsData} />
            </div>
        );
    }
}
